import { Injectable } from '@angular/core';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumnService } from '../services/table-column.service';
import { TableColumn } from '../../../models/table-column';
import { Pickup } from '../../../models/pickup';
import { CourierProfileService } from '../services/courier-profile.service';
import { EntityEnum } from 'src/app/enum/entity.enum';
import { PickupColumnEnum } from '../../../enum/pickup-column.enum';

@Injectable({ providedIn: 'root' })
export class PickupColumnsService implements TableColumnProvider {

    constructor(private tableColumnService: TableColumnService, private courierService: CourierProfileService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): TableColumn {
        switch (id) {
            case PickupColumnEnum.PICKUP_REFERENCE:
                return {
                    id: PickupColumnEnum.PICKUP_REFERENCE,
                    caption: $localize`Reference`,
                    width: 150,
                    sort: 'reference',
                    render: (pickup: Pickup) => pickup.reference
                };
            case PickupColumnEnum.PICKUP_DATE:
                return {
                    id: PickupColumnEnum.PICKUP_DATE,
                    caption: $localize`Date`,
                    width: 150,
                    sort: 'date',
                    render: (pickup: Pickup) => pickup.date
                };
            case PickupColumnEnum.PICKUP_COURIER:
                return {
                    id: PickupColumnEnum.PICKUP_COURIER,
                    caption: $localize`Courier`,
                    width: 200,
                    sort: 'courierModule',
                    render: (pickup: Pickup) => pickup.courierModule
                };
            case PickupColumnEnum.PICKUP_TIME_START:
                return {
                    id: PickupColumnEnum.PICKUP_TIME_START,
                    caption: $localize`Time Start`,
                    width: 150,
                    sort: 'startTime',
                    render: (pickup: Pickup) => pickup.startTime
                };
            case PickupColumnEnum.PICKUP_TIME_END:
                return {
                    id: PickupColumnEnum.PICKUP_TIME_END,
                    caption: $localize`Time End`,
                    width: 150,
                    sort: 'endTime',
                    render: (pickup: Pickup) => pickup.endTime
                };
        }

    }

    ids(): string[] {
        return [ PickupColumnEnum.PICKUP_REFERENCE, PickupColumnEnum.PICKUP_COURIER, PickupColumnEnum.PICKUP_DATE, PickupColumnEnum.PICKUP_TIME_START, PickupColumnEnum.PICKUP_TIME_END ];
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.PICKUP;
    }
}
